module.exports = __webpack_public_path__ + "static/media/icon-phone.3db2d5d3.svg";